import React, { useEffect, useState } from 'react';

import { toast } from 'react-toastify';
import customAxios from '../utils/customAxios';
import '../scss/Elements/_tables.scss';

import { Autocomplete, Divider, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GlobalVariables } from '../globalVar';
import { Helmet } from 'react-helmet';
import { SiteAssetsTableAxios } from '../components/Tables/SiteAssetsTable';
import { getToast } from '../utils/toastConfig';

function SiteAssets() {
  const navigate = useNavigate();

  const [countriesData, setCountriesData] = useState([]);
  const [statesData, setStatesData] = useState([]);
  const [citiesData, setCitiesData] = useState([]);
  const [coloniesData, setColoniesData] = useState([]);

  useEffect(() => {
    customAxios
      .get(`${GlobalVariables.getURL()}autofillCountryDetails`, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      })
      .then((response) => {
        setCountriesData(response.data.countries);
        setStatesData(response.data.states);
        setCitiesData(response.data.cities);
        setColoniesData(response.data.colonies);
      })
      .catch((error) => console.log(error));
  }, []);

  const getCountryStates = async (value) => {
    const response = await customAxios.get(
      `${GlobalVariables.getURL()}statesByCountry/${value}`,
      {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      }
    );
    return response.data;
  };

  const getStateCitites = async (value) => {
    const response = await customAxios.get(
      `${GlobalVariables.getURL()}cititesByState/${value}`,
      {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      }
    );
    return response.data;
  };

  const [firstSelection, setFirstSelection] = useState('');
  const [countryStates, setCountryStates] = useState([]);
  const [stateSelection, setStateSelection] = useState('');
  const [stateMunicipalities, setStateMunicipalities] = useState([]);

  const handleFirstSelection = async (event, value) => {
    setFirstSelection(value.id);
    setAddressCountryId(value.id);
    setCountryStates(await getCountryStates(value.id));
  };

  const handleStateSelection = async (event, value) => {
    setStateSelection(value.id);
    setAddressStateId(value.id);
    setStateMunicipalities(await getStateCitites(value.id));
  };

  var siteNameDefaultU = localStorage.getItem('siteNameForUpdate');
  var siteStreetDefaultU = localStorage.getItem('siteStreetForUpdate');
  var siteAddresNumberDefaultU = localStorage.getItem(
    'siteAddressNumberForUpdate'
  );
  var sitePCDefaultU = localStorage.getItem('sitePCForUpdate');

  var siteCountryIdDefaultU = localStorage.getItem('siteCountryIdForUpdate');
  var siteStateIdDefaultU = localStorage.getItem('siteStateIdForUpdate');
  var siteCityIdDefaultU = localStorage.getItem('siteCityIdForUpdate');
  var siteColonyIdDefaultU = localStorage.getItem('siteColonyIdForUpdate');

  var siteCountryNameDefaultU = localStorage.getItem(
    'siteCountryNameForUpdate'
  );
  var siteStateNameDefaultU = localStorage.getItem('siteStateNameForUpdate');
  var siteCityNameDefaultU = localStorage.getItem('siteCityNameForUpdate');
  var siteColonyNameDefaultU = localStorage.getItem('siteColonyNameForUpdate');

  const [name, setName] = useState(siteNameDefaultU);
  const [addressStreet, setAddressStreet] = useState(siteStreetDefaultU);
  const [addressNumber, setAddressNumber] = useState(siteAddresNumberDefaultU);

  const [addressColonyId, setAddressColonyId] = useState(siteColonyIdDefaultU);
  const [addressCityId, setAddressCityId] = useState(siteCityIdDefaultU);
  const [addressStateId, setAddressStateId] = useState(siteStateIdDefaultU);
  const [addressCountryId, setAddressCountryId] = useState(
    siteCountryIdDefaultU
  );

  const [addressColonyName, setAddressColonyName] = useState(
    siteColonyNameDefaultU
  );
  const [addressCityName, setAddressCityName] = useState(siteCityNameDefaultU);
  const [addressStateName, setAddressStateName] = useState(
    siteStateNameDefaultU
  );
  const [addressCountryName, setAddressCountryName] = useState(
    siteCountryNameDefaultU
  );

  const [addressPC, setAddressPC] = useState(sitePCDefaultU);

  const resetFormFields = () => {
    setName(localStorage.getItem('siteNameForUpdate'));
    setAddressStreet(localStorage.getItem('siteStreetForUpdate'));
    setAddressNumber(localStorage.getItem('siteAddressNumberForUpdate'));

    setAddressCountryId(localStorage.getItem('siteCountryIdForUpdate'));
    setAddressColonyId(localStorage.getItem('siteColonyIdForUpdate'));
    setAddressCityId(localStorage.getItem('siteCityIdForUpdate'));
    setAddressStateId(localStorage.getItem('siteStateIdForUpdate'));

    setAddressCountryName(localStorage.getItem('siteCountryNameForUpdate'));
    setAddressColonyName(localStorage.getItem('siteColonyNameForUpdate'));
    setAddressCityName(localStorage.getItem('siteCityNameForUpdate'));
    setAddressStateName(localStorage.getItem('siteStateNameForUpdate'));

    setAddressPC(localStorage.getItem('sitePCForUpdate'));
  };

  function updateSite(event) {
    event.preventDefault();
    var updateSiteId = localStorage.getItem('siteIdForUpdate');

    customAxios
      .patch(
        `${GlobalVariables.getURL()}updateSite/${updateSiteId}`,
        {
          site_name: name,
          address_street: addressStreet,
          address_number: addressNumber,
          address_colony: addressColonyName,
          address_city_id: addressCityId,
          address_state_id: addressStateId,
          address_country_id: addressCountryId,
          address_postal_code: addressPC,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      )
      .then(
        (response) => {
          window.history.back();
          getToast({
            status: 'success',
            title: 'Sucursal actualizada exitosamente en la base de datos.',
          });
        },
        (error) => {
          console.log(error);
          getToast({
            status: 'error',
            title: 'Error al actualizar sucursal. Vuelve a intentarlo.',
          });
        }
      );
  }

  useEffect(() => {
    // Verifica si existe un ID de país predeterminado
    if (addressCountryId) {
      // Llama a la función para cargar los estados del país predeterminado
      getCountryStates(addressCountryId).then((states) => {
        setCountryStates(states);
        // Aquí, además, puedes establecer el estado seleccionado si es necesario
        // Esto es útil si quieres reflejar en la UI el estado predeterminado seleccionado
      });
    }
  }, [addressCountryId]); // La dependencia es addressCountryId para que se ejecute cuando este cambie

  var siteBusinessNameForUPlaceholder = localStorage.getItem(
    'siteBusinessNameForUPlaceholder'
  );

  return (
    <div className="site-assets" onAnimationStart={resetFormFields}>
      <Helmet>
        <title>
          {siteBusinessNameForUPlaceholder +
            ` [${siteNameDefaultU}] | Durandal`}
        </title>
      </Helmet>
      <div className="site-assets-container">
        <Divider sx={{ height: '3%', marginBottom: '1%' }}>
          Actualizar sucursal
        </Divider>
        <div className="site-form-container">
          <form id="site-form-id" onSubmit={updateSite}>
            <div className="row">
              <div className="col-md-10">
                <TextField
                  sx={{ width: '100%' }}
                  label="Plaza"
                  type="text"
                  value={siteBusinessNameForUPlaceholder}
                  InputLabelProps={{ shrink: true }}
                  required
                  disabled
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-5">
                <TextField
                  sx={{ width: '100%' }}
                  label="Nombre de la sucursal"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="col-md-5">
                <TextField
                  sx={{ width: '100%' }}
                  label="Nombre de la calle"
                  type="text"
                  value={addressStreet}
                  onChange={(e) => setAddressStreet(e.target.value)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-5">
                <Autocomplete
                  sx={{ width: '100%' }}
                  disablePortal
                  includeInputInList={true}
                  options={countriesData}
                  defaultValue={{
                    id: addressCountryId,
                    co_name: addressCountryName,
                  }}
                  getOptionLabel={(countriesData) => countriesData.co_name}
                  getOptionSelected={(countriesData, value) =>
                    countriesData.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Seleccionar país..." />
                  )}
                  onChange={handleFirstSelection}
                />
              </div>
              <div className="col-md-5">
                <Autocomplete
                  sx={{ width: '100%' }}
                  disablePortal
                  includeInputInList={true}
                  options={countryStates}
                  defaultValue={{
                    id: addressStateId,
                    st_name: addressStateName,
                  }}
                  getOptionLabel={(countryStates) => countryStates.st_name}
                  getOptionSelected={(countryStates, value) =>
                    countryStates.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Seleccionar estado..." />
                  )}
                  onChange={handleStateSelection}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-5">
                <Autocomplete
                  sx={{ width: '100%' }}
                  disablePortal
                  includeInputInList={true}
                  options={stateMunicipalities}
                  defaultValue={{ id: addressCityId, ci_name: addressCityName }}
                  getOptionLabel={(stateMunicipalities) =>
                    stateMunicipalities.ci_name
                  }
                  getOptionSelected={(stateMunicipalities, value) =>
                    stateMunicipalities.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Seleccionar ciudad..." />
                  )}
                  onChange={(event, newValue) => {
                    setAddressCityId(newValue.id);
                  }}
                />
              </div>
              <div className="col-md-5">
                <TextField
                  sx={{ width: '100%' }}
                  label="Nombre de la colonia"
                  type="text"
                  value={addressColonyName}
                  onChange={(e) => setAddressColonyName(e.target.value)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-5">
                <TextField
                  sx={{ width: '100%' }}
                  label="Número de dirección"
                  type="number"
                  value={addressNumber}
                  onChange={(e) => setAddressNumber(e.target.value)}
                />
              </div>
              <div className="col-md-5">
                <TextField
                  sx={{ width: '100%' }}
                  label="Código postal"
                  type="number"
                  value={addressPC}
                  onChange={(e) => setAddressPC(e.target.value)}
                />
              </div>
            </div>
            <div className="button-container">
              <button type="submit" className="save-button" form="site-form-id">
                Actualizar cambios
              </button>
            </div>
          </form>
        </div>

        {/* <Divider sx={{ height: "3%" }}>Activos de la sucursal</Divider> */}

        <div className="assets-container">
          <div className="datatable" id="datatable-att">
            <SiteAssetsTableAxios />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SiteAssets;
